// SPDX-License-Identifier: Apache-2.0

/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import App from "./App";
import Landing from "./routes/Landing";
import Chat from "./routes/Chat";
import Sessions from "./routes/Sessions";
import History from "./routes/History";
import Temple from "./routes/Temple";
import Share from "./routes/Share";
import Settings from "./routes/Settings";
import Journey from "./routes/Journey";
import DevIndex from "./routes/dev/index";
import DevNotes from "./routes/dev/Notes";
import DevSearch from "./routes/dev/Search";
import DevOrbit from "./routes/dev/Orbit";
import DevComms from "./routes/dev/Comms";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

// Route map (Hermes spawn 7):
//   /         → Landing (3D atlas hero, ported from v1)
//   /vault    → Chat (the existing surface that mounts <VaultExperience/>)
//   /chat     → Chat (alias kept for backwards compat with deep links)
// The right-rail <ChatPanel/> is App-level chrome, mounted on every non-/dev
// route, so the brain agent is reachable from /vault and /chat alike.
render(
  () => (
    <Router root={App}>
      <Route path="/" component={Landing} />
      <Route path="/vault" component={Chat} />
      <Route path="/chat" component={Chat} />
      <Route path="/sessions" component={Sessions} />
      <Route path="/history" component={History} />
      <Route path="/temple" component={Temple} />
      <Route path="/share" component={Share} />
      <Route path="/journey" component={Journey} />
      <Route path="/settings" component={Settings} />
      <Route path="/dev" component={DevIndex} />
      <Route path="/dev/notes" component={DevNotes} />
      <Route path="/dev/search" component={DevSearch} />
      <Route path="/dev/orbit" component={DevOrbit} />
      <Route path="/dev/comms" component={DevComms} />
    </Router>
  ),
  root
);
